import { callApi } from 'loankeeper-common/api'

export const details = ({ ID, hash, page }) =>
  (ID || hash) &&
  callApi('collateral_view', {
    params: {
      CollateralID: ID,
      HashSum_CollateralID_: hash,
      page,
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const print = (params) =>
  callApi('collateral_view', {
    params,
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

// export const newEstimation = ({ CollateralID, HashSum_CollateralID_, CCY, ProductID, HashSum_ProductID_ }) =>
//   callApi('collateral_view', {
//     params: {
//       CollateralID,
//       HashSum_CollateralID_,
//       page: 'newestimation',
//       CCY,
//       ProductID,
//       HashSum_ProductID_,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

export const search = (params) =>
  callApi('collateral_search', {
    params,
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

// export const add = (params, body) =>
//   callApi('collateral_add', {
//     method: 'post',
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//     params,
//     body,
//   })

// export const oper = (params) =>
//   callApi('collateral_oper', {
//     params,
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const addPermission = (params) =>
//   callApi('collateral_oper', {
//     params: {
//       ...params,
//       action: 'accesspermadd',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const deletePermission = (params) =>
//   callApi('collateral_oper', {
//     params: {
//       ...params,
//       action: 'accesspermdelete',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const operations = ({ ID, CollateralID, hash, ...rest }) =>
//   callApi('collateral_oper', {
//     params: {
//       ID,
//       CollateralID,
//       HashSum_CollateralID_: hash,
//       ...rest,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const visaOperation = ({ ID, hash }) =>
//   callApi('collateral_oper', {
//     params: {
//       CollateralID: ID,
//       HashSum_CollateralID_: hash,
//       action: 'visa',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const undoVisaOperation = ({ ID, hash }) =>
//   callApi('collateral_oper', {
//     params: {
//       CollateralID: ID,
//       HashSum_CollateralID_: hash,
//       action: 'visaundo',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const updateAgreementNumber = (ID, hash, agreementNo) =>
//   callApi('collateral_oper', {
//     params: {
//       CollateralID: ID,
//       HashSum_CollateralID_: hash,
//       AgreementNo: agreementNo,
//       action: 'agreementnumberupdate',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const editState = ({ ID, hash, stateID }) => {
//   return callApi('collateral_oper', {
//     params: {
//       CollateralID: ID,
//       HashSum_CollateralID_: hash,
//       StateID: stateID,
//       action: 'stateupdate',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })
// }

// export const editDetailState = ({ ID, hash, detailID, detailHash, stateID }) =>
//   callApi('collateral_oper', {
//     params: {
//       CollateralID: ID,
//       HashSum_CollateralID_: hash,
//       DetailID: detailID,
//       HashSum_DetailID_: detailHash,
//       DetailStateID: stateID,
//       action: 'detailstateupdate',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const visa = (ID, hash) =>
//   callApi('collateral_oper', {
//     params: {
//       CollateralID: ID,
//       HashSum_CollateralID_: hash,
//       action: 'visa',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const undoVisa = (ID, hash) =>
//   callApi('collateral_oper', {
//     params: {
//       CollateralID: ID,
//       HashSum_CollateralID_: hash,
//       action: 'visaundo',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const updateDesc = ({ CollateralID, HashSum_CollateralID_, Description }) =>
//   oper({ CollateralID, HashSum_CollateralID_, Description, action: 'updatedesc' })
